/**
 * Text that carries its full value in a tooltip only while it is cut
 * (#6559 round 18c, Claude Design): a pill or a metadata line that fits
 * says everything already, and a tooltip on it would only repeat it. The
 * value in the tooltip is the visible text itself — never an internal key.
 */
import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";

/** Whether the element's text overflows its box, kept current on resize. */
export const useCut = (): [
  React.RefObject<HTMLSpanElement | null>,
  boolean,
] => {
  const ref = useRef<HTMLSpanElement | null>(null);
  const [cut, setCut] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setCut(el.scrollWidth > el.clientWidth + 1);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return [ref, cut];
};

const CutText: React.FC<{
  text: string;
  className?: string;
  style?: React.CSSProperties;
}> = ({ text, className, style }) => {
  const [ref, cut] = useCut();
  return (
    <Tooltip title={cut ? text : ""} placement="top">
      <span ref={ref} className={className} style={style}>
        {text}
      </span>
    </Tooltip>
  );
};

export default CutText;
